import React from 'react';
import QuillEditorWithImageResize from '../QuillEditorWithImageResize';

interface ScratchStemEditorProps {
  value: string;
  onChange: (content: string, widths?: number[]) => void;
  questionId: string;
  imageWidths?: number[];
}

/**
 * Scratch/Python/C++ 题目题干区编辑器
 * 使用 QuillEditorWithImageResize 实现富文本编辑，支持图文混排
 *
 * 设计说明：
 * - QuillEditorWithImageResize 内部已是"非受控模式"，通过 key={questionId_targetField}
 *   处理题目切换；外层父组件（PythonQuestionEditor 等）通过 key={stem-${id}-${editSessionId}}
 *   处理"取消修改"场景的强制重建。
 * - 这里【不能】再监听 value 变化去 setVersion 强制重建，否则：
 *   1) 用户拖拽图片缩放 → onChange(html, widths) → 父组件 updateDraft({content, titleImageWidths})
 *   2) editDraft.content 变化 → 本组件 value prop 变化 → useEffect 触发 setVersion
 *   3) QuillEditorWithImageResize 重新挂载 → 从 defaultValue 重新加载
 *      但此时 imageWidths prop 可能还是旧值（React 异步批处理），width% 注入用旧宽度
 *      → 图片缩放值丢失，无法持久化
 *   4) 更严重：每次输入文字也会触发 value 变化 → 每次输入都重建编辑器 → 无法正常编辑
 */
export default function ScratchStemEditor({
  value,
  onChange,
  questionId,
  imageWidths = []
}: ScratchStemEditorProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">题干内容</label>
      <QuillEditorWithImageResize
        key={`${questionId}-stem`}
        value={value}
        onChange={onChange}
        questionId={`${questionId}-stem`}
        targetField="content"
        imageWidths={imageWidths}
        applyRealtimeScaling={true}
        placeholder="请输入题目内容，支持图文混排..."
      />
    </div>
  );
}
